import { trpc } from "../trpc";

export function useChatbotsLimits() {
  const { data: usage, isLoading } = trpc.chatbot.usage.useQuery();

  return {
    chatbotCount: usage?.chatbotCount,
    chatbotLimit: usage?.chatbotLimit,
    planName: usage?.planName,
    isLoading,
  };
}
